import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PlannedOutagesResponse } from '../model/plannedoutagesresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';

@Injectable()

export class RelatedPlannedOutagesService {
    constructor (public http: HttpClient) {}

    public getRelatedPlannedOutages(plannedOutageId: number): Observable<PlannedOutagesResponse> {

        return this.http.get<PlannedOutagesResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/plannedoutages/' + plannedOutageId + '/relatedplannedoutages');

    }
}
